import React from 'react';
import {
    Card, CardHeader, Box, Table, TableContainer, TableHead,
    TableRow, TableBody, Select, FormControl, MenuItem,
    Checkbox, FormControlLabel
} from '@mui/material';
import { SmallCell } from '../style/tablecell';
import { TypographyBold, TypographyNomalBold, TypographyNomal } from '../style/typography';

const TaskAssignmentTable = ({ title, onAssignmentChange, category, damTaskList, powerpointTaskList, noAssignUserList, assignedList, onNotifyChange, isNotifyDialogOpen }) => {

    const currentTaskRows = category === 'dam' ? damTaskList : powerpointTaskList;

    // 業務UUIDとスロットで割当ユーザーを検索する関数
    const getAssignedUser = (workUuid, slot) => {
        if (!assignedList || assignedList.length === 0) return null;

        const assignment = assignedList.find(item => item.work_uuid === workUuid);
        if (assignment) {
            const nameKey = `user_name0${slot}`;
            const uuidKey = `user_uuid0${slot}`;
            const smsStatusKey = `is_assign_sent0${slot}`;

            if (assignment[uuidKey] && assignment[nameKey]) {
                return {
                    name: assignment[nameKey],
                    uuid: assignment[uuidKey],
                    // DBから取得した値（true/false/null）を使用。nullやfalseは未送信(false)と見なす
                    smsStatus: assignment[smsStatusKey] || false
                };
            }
        }
        return null;
    };

    // 業務に担当者が割り当てられているかチェックする関数
    const hasAssignedUsers = (workUuid) => {
        const assignedUser1 = getAssignedUser(workUuid, 1);
        const assignedUser2 = getAssignedUser(workUuid, 2);

        // 担当者1または担当者2のどちらかが存在すればtrue
        return !!(assignedUser1 || assignedUser2);
    };

    const handleCheckboxChange = (event, workUuid) => {
        onNotifyChange(workUuid, event.target.checked, category);
    };

    const renderAssignmentCell = (row, slot) => {
        const assignedUser = getAssignedUser(row.uuid, slot);
        const valueKey = slot === 1 ? 'value1' : 'value2';

        // 状態3: SMS送信済み（assignedUserが存在し、smsStatus === true）→ テキスト表示のみ
        if (assignedUser && assignedUser.smsStatus === true) {
            return <TypographyNomal>{assignedUser.name}</TypographyNomal>;
        }

        // 業務割当て済み+SMS未送信ユーザーと、業務未割り当てユーザーをリスト化
        let selectableUserList = [...noAssignUserList];
        assignedList.forEach((item) => {
            for (let i = 1; i <= 2; i++) {
                const nameKey = `user_name0${i}`;
                const uuidKey = `user_uuid0${i}`;
                const smsStatusKey = `is_assign_sent0${i}`;
                if (item[uuidKey] && !item[smsStatusKey]) { // SMS未送信
                    if (!selectableUserList.some(u => u.uuid === item[uuidKey])) {
                        selectableUserList.push({
                            uuid: item[uuidKey],
                            full_name: item[nameKey],
                        });
                    }
                }
            }
        });

        // 選択内容の設定
        let selectValue = row[valueKey] !== undefined ? row[valueKey] : (assignedUser ? assignedUser.uuid : '');
        return (
            <FormControl fullWidth>
                <Select
                    labelId={`assignment-select-label-${row.uuid}-0${slot}`}
                    value={selectValue}
                    onChange={(e) => onAssignmentChange(row.uuid, slot, e.target.value, category)}
                >
                    <MenuItem value=""> - </MenuItem>
                    {selectableUserList.map((user) => (
                        <MenuItem
                            key={user.uuid}
                            value={user.uuid}
                        >
                            {user.full_name}
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
        );
    };

    return (
        <Card
            variant="outlined"
            sx={{
                border: '1px solid rgb(232, 234, 238)',
                boxShadow: '0px 0px 0px 0px rgba(0, 0, 0, 0.2), 0px 1px 0px 0px rgba(0, 0, 0, 0.14), 0px 2px 0px 0px rgba(0, 0, 0, 0.12)',
                marginTop: 1,
                width: '100%',
            }}
        >
            <CardHeader
                title={<TypographyBold>{title}</TypographyBold>}
            />
            <Box sx={{ boxSizing: 'border-box' }}>
                <TableContainer>
                    <Table
                        sx={{
                            '& .MuiTableCell-root': {
                                width: 'auto',
                                minWidth: 'auto',
                            },
                            '& .MuiTableCell-root:first-of-type': {
                                width: '80px',
                                minWidth: '80px',
                            },
                        }}
                    >
                        <TableHead>
                            <TableRow>
                                <SmallCell><TypographyNomalBold>通知</TypographyNomalBold></SmallCell>
                                <SmallCell><TypographyNomalBold>業務名</TypographyNomalBold></SmallCell>
                                <SmallCell><TypographyNomalBold>担当者1</TypographyNomalBold></SmallCell>
                                <SmallCell><TypographyNomalBold>担当者2</TypographyNomalBold></SmallCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {currentTaskRows.map((row) => {
                                const isAssigned = hasAssignedUsers(row.uuid);

                                return (
                                    <TableRow key={row.uuid}>
                                        <SmallCell sx={{ width: '80px', minWidth: '80px' }}>
                                            <FormControlLabel
                                                control={
                                                    <Checkbox
                                                        checked={!!row.notify_checked}
                                                        onChange={(e) => handleCheckboxChange(e, row.uuid)}
                                                        disabled={!isAssigned || isNotifyDialogOpen}
                                                    />
                                                }
                                            />
                                        </SmallCell>
                                        <SmallCell>{row.name}</SmallCell>

                                        {/* 担当者1のセル */}
                                        <SmallCell>
                                            {renderAssignmentCell(row, 1)}
                                        </SmallCell>

                                        {/* 担当者2のセル */}
                                        <SmallCell>
                                            {renderAssignmentCell(row, 2)}
                                        </SmallCell>
                                    </TableRow>
                                )
                            })}
                        </TableBody>
                    </Table>
                </TableContainer>
            </Box>
        </Card>
    );
};

export default TaskAssignmentTable;